import { message, Modal, Spin } from "antd";
import { useState, useEffect } from "react";
const Index = (props) => {
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (props?.open) {
      setSelected(null);
      setDataLoading(true);
      props?.request({ url: "/device/popup", method: "POST" })?.then((res) => {
        setDataLoading(false);
        if (res.success) {
          setData(res.data);
        } else {
          message.error(res.message);
        }
      });
    }
  }, [props?.open]);

  const handleSaveUpdate = () => {
    if (selected) {
      setLoading(true);
      let body = {
        updateid: selected?.id,
        carids: props?.selectedRows?.map((item) => item?.id),
      };

      props
        ?.request({ url: "/device/car", method: "POST", body: body })
        ?.then((res) => {
          setLoading(false);
          if (res?.success) {
            message.success(res.message);
            props?.callBack();
          } else {
            message.error(res.message);
          }
        });
    } else {
      message.error("Та update хийх файл сонгоно уу");
    }
  };

  return (
    <Modal
      title="Update файл сонгоно уу"
      open={props?.open}
      onCancel={props?.onClose}
      width={500}
      onOk={handleSaveUpdate}
      okButtonProps={{ loading: loading, text: "" }}
      okText="Update эхлүүлэх"
      isShowFooter={false}
      height={"60%"}
    >
      <Spin spinning={dataLoading}>
        <div className="flex flex-col  gap-1.5 h-96 overflow-y-auto">
          {data?.map((item, i) => (
            <div
              key={i}
              className={`flex flex-col cursor-pointer flex flex-col border rounded-md p-2 ${
                item?.id === selected?.id ? "border-active" : ""
              }`}
              onClick={() => {
                setSelected(item);
              }}
            >
              <span className="font-semibold">{item?.version}</span>
              <span className="text-xs">{item?.description}</span>
            </div>
          ))}
        </div>
      </Spin>
    </Modal>
  );
};

export default Index;
